import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import TextButton from 'components/Luxkit/Button/TextButton'
import BodyText from 'components/Luxkit/Typography/BodyText'
import React, { useCallback, useContext, ReactElement } from 'react'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import ModalContext from 'contexts/ModalContext'
import LandingPageLoyaltyDiscountedInsuranceBenefitsModal from './LandingPageLoyaltyDiscountedInsuranceBenefitsModal'

const image: App.Image = {
  id: '36fmxwdnmim0b53p9x7',
  title: 'Travel & Cancellation Protection',
}

interface Props {
  tier: App.LoyaltyTier
  benefitLabel: ReactElement
  discountPercent: number
}

function LandingPageLoyaltyDiscountedInsurance(props: Props) {
  const { tier, benefitLabel, discountPercent } = props

  const showModal = useContext(ModalContext)

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyDiscountedInsuranceBenefitsModal
      image={image}
      tier={tier}
      discountPercent={discountPercent}
    />)
  }, [showModal, tier, discountPercent])

  return <LandingPageLoyaltyBenefitTile
    heading={`Save ${discountPercent}% on Travel & Cancellation Protection`}
    labels={<LoyaltyTierLabel kind="primary" tier={tier}>{benefitLabel}</LoyaltyTierLabel>}
    image={image}
    actions={<TextButton kind="secondary" onClick={handleDetailsClick}>
      Details
    </TextButton>}
  >
    <BodyText variant="medium">
      Travel with confidence. Enjoy {discountPercent}% off comprehensive travel protection,{' '}
      including cover for trip cancellations, medical emergencies, lost luggage and more. Peace of mind, for less.
    </BodyText>
  </LandingPageLoyaltyBenefitTile>
}

export default LandingPageLoyaltyDiscountedInsurance
